/* eslint-disable */
/** Auto-generated by scripts/i18n/compile-translations.sh — do not edit */
export type Locale = 'en' | 'fr'
export const SUPPORTED_LOCALES: Locale[] = ['en', 'fr']
export const DEFAULT_LOCALE: Locale = 'fr'
export const BUNDLED_MESSAGES: Record<Locale, Record<string, string>> = {
  en: {
    'advanced.activeOnly': '✅ Active only',
    'advanced.date.all': 'Any time',
    'advanced.date.month': 'This month',
    'advanced.date.today': 'Today',
    'advanced.date.week': 'This week',
    'advanced.date.year': 'This year',
    'advanced.forks': '🍴 Forks',
    'advanced.options': 'Options',
    'advanced.placeholder.max': 'Max',
    'advanced.placeholder.min': 'Min',
    'advanced.reset': '🔄 Reset advanced filters',
    'advanced.stars': '⭐ Stars',
    'advanced.title': '🔍 Advanced filters',
    'advanced.toggle.hide': 'Hide advanced filters',
    'advanced.toggle.show': 'Show advanced filters',
    'advanced.updated.label': '📅 Last updated',
    'advanced.withHomepage': '🌐 With deployment URL',
    'buttons.dismiss': 'Dismiss',
    'buttons.favorite.add': 'Add to favorites',
    'buttons.favorite.remove': 'Remove from favorites',
    'connection.checking': 'Checking connection…',
    'connection.hint1': 'Start the backend: uvicorn app.main:app --reload --port 8080',
    'connection.hint2': 'Ensure port 8080 is not used by another process',
    'connection.hint3': 'Check your network connection',
    'connection.hint4': 'Verify the backend URL in environment variables',
    'connection.retry': '🔄 Retry connection',
    'connection.solutionsTitle': '💡 Possible fixes:',
    'connection.title': 'Backend connection',
    'empty.adjustFilters': 'Try adjusting your search filters',
    'empty.noResults': 'No repositories found',
    'empty.noneAvailable': 'No repositories available right now',
    'empty.resetFilters': 'Reset filters',
    'errors.auth.description': 'The GitHub token is missing or invalid.',
    'errors.auth.solution': 'Ensure GITHUB_TOKEN is set on the backend or configure a token in the app.',
    'errors.auth.title': '🔐 Authentication error',
    'errors.debug.apiUrl': 'API URL:',
    'errors.debug.fullError': 'Full error:',
    'errors.debug.mode': 'Environment:',
    'errors.debug.summary': 'Debug information',
    'errors.generic': 'Something went wrong',
    'errors.generic.description': '{detail}',
    'errors.generic.solution': 'Check server logs for details.',
    'errors.generic.title': '❌ Error',
    'errors.network.description': 'Could not reach the backend server.',
    'errors.network.solution': 'Start the backend: uvicorn app.main:app --reload --port 8080',
    'errors.network.title': '🌐 Connection error',
    'errors.permission.description': 'GitHub rate limit or insufficient permissions.',
    'errors.permission.solution': 'Wait a few minutes or check your token permissions.',
    'errors.permission.title': '🚫 Access denied',
    'errors.rateLimit.description': 'You exceeded the GitHub API rate limit.',
    'errors.rateLimit.solution': 'Wait before trying again.',
    'errors.rateLimit.title': '⏱️ Too many requests',
    'errors.reloadPage': '🔃 Reload page',
    'errors.retry': '🔄 Retry',
    'errors.solution.label': 'Solution:',
    'errors.timeout.description': 'The request took too long.',
    'errors.timeout.solution': 'Try again in a moment.',
    'errors.timeout.title': '⏰ Timeout',
    'errors.token.required': 'GitHub token is required',
    'errors.token.saveFailed': 'Could not save the token',
    'errors.token.tooShort': 'Token looks invalid (too short)',
    'forms.clearSearch.ariaLabel': 'Clear search',
    'forms.language.all': '🌐 Language (all)',
    'forms.language.ariaLabel': 'Filter by language',
    'forms.perPage.ariaLabel': 'Results per page',
    'forms.perPage.option': '{n}/page',
    'forms.private.ariaLabel': 'Include private repositories',
    'forms.private.label': '🔒 Private',
    'forms.reset': '🔄 Reset',
    'forms.reset.title': 'Reset all filters',
    'forms.search.ariaLabel': 'Repository search',
    'forms.search.placeholder': 'Search repositories…',
    'forms.sort.ariaLabel': 'Sort results',
    'forms.sort.stars': '⭐ Sort: Stars',
    'forms.sort.updated': '🕒 Sort: Recently updated',
    'forms.topic.all': '🏷️ Topic (all)',
    'forms.topic.ariaLabel': 'Filter by topic',
    'loading.default': 'Loading…',
    'loading.repos': 'Loading GitHub repositories…',
    'nav.aria.language': 'Language',
    'nav.brand': 'GitXplorer Project ListGithub',
    'nav.favorites': 'Favorites',
    'nav.favoritesTitle': 'Show {count} favorite(s)',
    'nav.home': 'Home',
    'nav.locale.en': 'EN',
    'nav.locale.fr': 'FR',
    'nav.stats': 'Stats',
    'nav.statsHide': 'Hide statistics',
    'nav.statsShow': 'Show statistics',
    'nav.themeToggle': 'Toggle theme',
    'pages.landing.b0': 'Save time',
    'pages.landing.b1': 'Higher productivity',
    'pages.landing.b2': 'Detailed analytics',
    'pages.landing.b3': 'Stronger security',
    'pages.landing.b4': 'Optimal performance',
    'pages.landing.b5': 'Intuitive interface',
    'pages.landing.badgeFast': '⚡ Lightning fast',
    'pages.landing.badgeNew': '🚀 New',
    'pages.landing.badgeSecure': '🔒 Secure',
    'pages.landing.codeTitle': 'GraphQL example',
    'pages.landing.compare.favorites.classic': '❌',
    'pages.landing.compare.favorites.label': 'Favorites',
    'pages.landing.compare.favorites.platform': '✅',
    'pages.landing.compare.filters.classic': '⚠️ Limited',
    'pages.landing.compare.filters.label': 'Advanced filters',
    'pages.landing.compare.filters.platform': '✅ Full',
    'pages.landing.compare.header.classic': 'Classic tools',
    'pages.landing.compare.header.feature': 'Capability',
    'pages.landing.compare.header.platform': 'GitXplorer Project ListGithub',
    'pages.landing.compare.performance.classic': '⚠️ Variable',
    'pages.landing.compare.performance.label': 'Performance',
    'pages.landing.compare.performance.platform': '✅ Optimized',
    'pages.landing.compare.readme.classic': '❌',
    'pages.landing.compare.readme.label': 'README preview',
    'pages.landing.compare.readme.platform': '✅',
    'pages.landing.compare.stats.classic': '⚠️ Basic',
    'pages.landing.compare.stats.label': 'Detailed statistics',
    'pages.landing.compare.stats.platform': '✅ Advanced',
    'pages.landing.compare.ui.classic': '⚠️ Dated',
    'pages.landing.compare.ui.label': 'Modern UI',
    'pages.landing.compare.ui.platform': '✅ Modern',
    'pages.landing.cta.button': 'Get started',
    'pages.landing.cta.subtitle': 'Join developers who use GitXplorer Project ListGithub to manage GitHub projects efficiently',
    'pages.landing.cta.title': 'Ready to explore your repositories?',
    'pages.landing.cta.trust1': '✅ Free',
    'pages.landing.cta.trust2': '✅ Open source',
    'pages.landing.cta.trust3': '✅ No signup',
    'pages.landing.ctaLong': 'Start exploring',
    'pages.landing.f0.desc': 'Browse all your GitHub repositories with smart pagination, advanced filters and real-time search.',
    'pages.landing.f0.title': 'Full exploration',
    'pages.landing.f1.desc': 'Filter by language, topics, stars, forks, last update and more.',
    'pages.landing.f1.title': 'Advanced search',
    'pages.landing.f2.desc': 'View READMEs in the app with formatted HTML rendering.',
    'pages.landing.f2.title': 'README preview',
    'pages.landing.f3.desc': 'Save preferred repositories and access them quickly with persistent favorites.',
    'pages.landing.f3.title': 'Favorites',
    'pages.landing.f4.desc': 'Analyze repositories with rich metrics: stars, forks, languages and more.',
    'pages.landing.f4.title': 'Detailed statistics',
    'pages.landing.f5.desc': 'Smart cache with automatic TTL for fast responses and a smooth experience.',
    'pages.landing.f5.title': 'Optimal performance',
    'pages.landing.f6.desc': 'Secure GitHub token handling with validation and local browser storage.',
    'pages.landing.f6.title': 'Strong security',
    'pages.landing.f7.desc': 'Monitoring with Prometheus, Grafana and Alertmanager for real-time insight.',
    'pages.landing.f7.title': 'Built-in monitoring',
    'pages.landing.feature.learnMore': 'Learn more →',
    'pages.landing.footer.brand': '📦 GitXplorer Project ListGithub',
    'pages.landing.footer.copy': '© 2024 GitXplorer Project ListGithub • Open Source',
    'pages.landing.footer.featLine1': 'Smart cache • Rate limiting',
    'pages.landing.footer.featLine2': 'Prometheus metrics • Structured logging',
    'pages.landing.footer.featTitle': 'Features',
    'pages.landing.footer.tagline': 'Advanced GitHub repository exploration',
    'pages.landing.footer.techLine1': 'FastAPI • React • TypeScript',
    'pages.landing.footer.techLine2': 'Prometheus • Grafana • Docker',
    'pages.landing.footer.techTitle': 'Technologies',
    'pages.landing.heroDesc': 'GitXplorer Project ListGithub gives you a modern UI to discover, filter and explore repositories — README preview, favorites, detailed stats and more.',
    'pages.landing.heroSubtitle': 'Filters, favorites, README preview and metrics — in one place.',
    'pages.landing.heroTitle': 'Explore your GitHub repositories',
    'pages.landing.heroTitleA': 'Explore and manage your GitHub repositories',
    'pages.landing.heroTitleB': ' easily',
    'pages.landing.logoSubtitle': 'Advanced GitHub exploration',
    'pages.landing.preview.favs': 'Favorites',
    'pages.landing.preview.readme': 'README preview',
    'pages.landing.preview.stats': 'Statistics',
    'pages.landing.s0.label': 'Repositories explored',
    'pages.landing.s1.label': 'Filters available',
    'pages.landing.s2.label': 'Response time',
    'pages.landing.s3.label': 'Uptime',
    'pages.landing.section.compareSubtitle': 'Compared with traditional approaches',
    'pages.landing.section.compareTitle': 'Why choose GitXplorer Project ListGithub?',
    'pages.landing.section.featuresSubtitle': 'Everything you need to explore and manage your GitHub repositories efficiently',
    'pages.landing.section.featuresTitle': 'Powerful features',
    'pages.landing.section.howSubtitle': 'In a few simple steps',
    'pages.landing.section.howTitle': 'How it works',
    'pages.landing.section.testimonialsSubtitle': 'How GitXplorer Project ListGithub helps developers manage their projects',
    'pages.landing.section.testimonialsTitle': 'What our users say',
    'pages.landing.statsTitle': 'Why GitXplorer Project ListGithub',
    'pages.landing.step1.desc': 'Add your personal GitHub token to access private repositories',
    'pages.landing.step1.title': 'Configure your token',
    'pages.landing.step2.desc': 'Browse all repos with advanced filters and powerful search',
    'pages.landing.step2.title': 'Explore your repositories',
    'pages.landing.step3.desc': 'View READMEs, add favorites and review statistics',
    'pages.landing.step3.title': 'Analyze and manage',
    'pages.landing.t0.name': 'Alex Dev',
    'pages.landing.t0.role': 'Full-stack developer',
    'pages.landing.t0.text': 'GitXplorer Project ListGithub changed how I manage GitHub repos. Advanced filters and README preview are outstanding.',
    'pages.landing.t1.name': 'Sarah Tech',
    'pages.landing.t1.role': 'Tech lead',
    'pages.landing.t1.text': 'The UI is intuitive and statistics help me understand my projects. An essential tool.',
    'pages.landing.t2.name': 'Mike Code',
    'pages.landing.t2.role': 'Open source contributor',
    'pages.landing.t2.text': 'Favorites and advanced search help me organize hundreds of repositories. Excellent work.',
    'pagination.next': 'Next ▶',
    'pagination.nextAria': 'Next page',
    'pagination.pageOf': 'Page {current} / {total}',
    'pagination.prev': '◀ Previous',
    'pagination.prevAria': 'Previous page',
    'pagination.totalRepos': '({total} repositories)',
    'readme.close': 'Close',
    'readme.closeAria': 'Close',
    'readme.empty': 'No README content for this repository',
    'readme.loadError': 'Could not load README',
    'readme.loading': 'Loading README…',
    'readme.notFound': 'No README for this repository',
    'readme.openGithub': '📂 View on GitHub',
    'readme.subtitle': '{owner}/{repo}',
    'readme.title': 'README — {repo}',
    'repo.archivedBadge': 'Archived',
    'repo.deployBadge': 'Deploy',
    'repo.github': '📂 GitHub',
    'repo.meta.forksTitle': 'Forks',
    'repo.meta.languageTitle': 'Programming language',
    'repo.meta.starsTitle': 'Stars',
    'repo.moreTopics': '+{n}',
    'repo.openApp': '🌐 Open app',
    'repo.readme': '📖 README',
    'repo.topicTitle': 'Topic: {topic}',
    'results.count': '{n} repository shown',
    'results.countPlural': '{n} repositories shown',
    'results.ofTotal': ' of {total}',
    'stats.card.activeRepos': 'Active repositories',
    'stats.card.languages': 'Languages',
    'stats.card.totalForks': 'Total forks',
    'stats.card.totalRepos': 'Total repositories',
    'stats.card.totalStars': 'Total stars',
    'stats.card.withDeploy': 'With deployment',
    'stats.extra.avg': 'Average: {n}',
    'stats.extra.percent': '{n}%',
    'stats.extra.top': 'Top: {name}',
    'stats.extra.totalLabel': 'Total: {n}',
    'stats.title': '📊 Statistics',
    'stats.topLanguages': '🔝 Top 5 languages',
    'stats.topics.one': '{n} unique topic',
    'stats.topics.other': '{n} unique topics',
    'toast.tokenError': 'Error saving token',
    'toast.tokenRemoveError': 'Error removing token',
    'toast.tokenRemoved': 'GitHub token removed',
    'toast.tokenSaved': 'GitHub token saved successfully!',
    'token.cancel': 'Cancel',
    'token.close': 'Close',
    'token.header': 'GitHub token',
    'token.help.step1': 'Open GitHub → Settings → Developer settings → Personal access tokens.',
    'token.help.step2': 'Click “Generate new token (classic)”.',
    'token.help.step3': 'Select scopes: public_repo, read:user.',
    'token.help.step4': 'Copy the token and paste it here.',
    'token.help.title': '💡 How to get a GitHub token',
    'token.help.warning': '⚠️ Important: the token is stored in your browser and is only sent to the API for GitHub requests.',
    'token.label': 'Personal access token',
    'token.placeholder': 'ghp_xxxxxxxxxxxxxxxxxxxx',
    'token.remove': '🗑️ Remove token',
    'token.status.active': 'Configured',
    'token.status.inactive': 'Not configured',
    'token.submit': '✅ Save token',
    'token.toggle.collapse': 'Collapse',
    'token.toggle.expand': 'Expand',
    'token.validating': '⏳ Validating…',
    'token.visibility.hide': 'Hide',
    'token.visibility.show': 'Show',
  },
  fr: {
    'advanced.activeOnly': '✅ Actifs uniquement',
    'advanced.date.all': 'Toutes les dates',
    'advanced.date.month': 'Ce mois',
    'advanced.date.today': 'Aujourd\'hui',
    'advanced.date.week': 'Cette semaine',
    'advanced.date.year': 'Cette année',
    'advanced.forks': '🍴 Forks',
    'advanced.options': 'Options',
    'advanced.placeholder.max': 'Max',
    'advanced.placeholder.min': 'Min',
    'advanced.reset': '🔄 Réinitialiser les filtres',
    'advanced.stars': '⭐ Étoiles',
    'advanced.title': '🔍 Filtres avancés',
    'advanced.toggle.hide': 'Masquer les filtres avancés',
    'advanced.toggle.show': 'Afficher les filtres avancés',
    'advanced.updated.label': '📅 Dernière mise à jour',
    'advanced.withHomepage': '🌐 Avec déploiement',
    'buttons.dismiss': 'Fermer',
    'buttons.favorite.add': 'Ajouter aux favoris',
    'buttons.favorite.remove': 'Retirer des favoris',
    'connection.checking': 'Vérification de la connexion…',
    'connection.hint1': 'Vérifiez que le backend est démarré : uvicorn app.main:app --reload --port 8080',
    'connection.hint2': 'Vérifiez que le port 8080 n\'est pas utilisé par un autre processus',
    'connection.hint3': 'Vérifiez votre connexion réseau',
    'connection.hint4': 'Vérifiez que l\'URL du backend est correcte dans les variables d\'environnement',
    'connection.retry': '🔄 Réessayer la connexion',
    'connection.solutionsTitle': '💡 Solutions possibles :',
    'connection.title': 'Connexion au backend',
    'empty.adjustFilters': 'Essayez de modifier vos filtres de recherche',
    'empty.noResults': 'Aucun dépôt trouvé',
    'empty.noneAvailable': 'Aucun dépôt disponible pour le moment',
    'empty.resetFilters': 'Réinitialiser les filtres',
    'errors.auth.description': 'Le token GitHub n\'est pas configuré ou est invalide.',
    'errors.auth.solution': 'Vérifiez que la variable GITHUB_TOKEN est définie côté backend ou configurez un token dans l\'application.',
    'errors.auth.title': '🔐 Erreur d\'authentification',
    'errors.debug.apiUrl': 'URL API :',
    'errors.debug.fullError': 'Erreur complète :',
    'errors.debug.mode': 'Environnement :',
    'errors.debug.summary': 'Informations de débogage',
    'errors.generic': 'Une erreur est survenue',
    'errors.generic.description': '{detail}',
    'errors.generic.solution': 'Consultez les logs du serveur pour plus de détails.',
    'errors.generic.title': '❌ Erreur',
    'errors.network.description': 'Impossible de joindre le serveur backend.',
    'errors.network.solution': 'Démarrez le backend : uvicorn app.main:app --reload --port 8080',
    'errors.network.title': '🌐 Erreur de connexion',
    'errors.permission.description': 'Limite de débit GitHub ou permissions insuffisantes.',
    'errors.permission.solution': 'Attendez quelques minutes ou vérifiez les permissions du token.',
    'errors.permission.title': '🚫 Accès refusé',
    'errors.rateLimit.description': 'Vous avez dépassé la limite de requêtes vers l\'API GitHub.',
    'errors.rateLimit.solution': 'Attendez avant de réessayer.',
    'errors.rateLimit.title': '⏱️ Trop de requêtes',
    'errors.reloadPage': '🔃 Recharger la page',
    'errors.retry': '🔄 Réessayer',
    'errors.solution.label': 'Solution :',
    'errors.timeout.description': 'La requête a pris trop de temps.',
    'errors.timeout.solution': 'Réessayez dans quelques instants.',
    'errors.timeout.title': '⏰ Délai dépassé',
    'errors.token.required': 'Le token GitHub est requis',
    'errors.token.saveFailed': 'Erreur lors de l\'enregistrement du token',
    'errors.token.tooShort': 'Le token semble invalide (trop court)',
    'forms.clearSearch.ariaLabel': 'Effacer la recherche',
    'forms.language.all': '🌐 Langage (tous)',
    'forms.language.ariaLabel': 'Filtrer par langage',
    'forms.perPage.ariaLabel': 'Nombre de résultats par page',
    'forms.perPage.option': '{n}/page',
    'forms.private.ariaLabel': 'Inclure les dépôts privés',
    'forms.private.label': '🔒 Privés',
    'forms.reset': '🔄 Réinitialiser',
    'forms.reset.title': 'Réinitialiser tous les filtres',
    'forms.search.ariaLabel': 'Recherche de dépôts',
    'forms.search.placeholder': 'Rechercher dans les dépôts…',
    'forms.sort.ariaLabel': 'Trier les résultats',
    'forms.sort.stars': '⭐ Tri : étoiles',
    'forms.sort.updated': '🕒 Tri : récent',
    'forms.topic.all': '🏷️ Topic (tous)',
    'forms.topic.ariaLabel': 'Filtrer par topic',
    'loading.default': 'Chargement…',
    'loading.repos': 'Chargement des dépôts GitHub…',
    'nav.aria.language': 'Langue',
    'nav.brand': 'GitXplorer Project ListGithub',
    'nav.favorites': 'Favoris',
    'nav.favoritesTitle': 'Afficher {count} favori(s)',
    'nav.home': 'Accueil',
    'nav.locale.en': 'EN',
    'nav.locale.fr': 'FR',
    'nav.stats': 'Stats',
    'nav.statsHide': 'Masquer les statistiques',
    'nav.statsShow': 'Afficher les statistiques',
    'nav.themeToggle': 'Basculer le thème',
    'pages.landing.b0': 'Gain de temps',
    'pages.landing.b1': 'Productivité accrue',
    'pages.landing.b2': 'Analyses détaillées',
    'pages.landing.b3': 'Sécurité renforcée',
    'pages.landing.b4': 'Performance optimale',
    'pages.landing.b5': 'Interface intuitive',
    'pages.landing.badgeFast': '⚡ Ultra rapide',
    'pages.landing.badgeNew': '🚀 Nouveau',
    'pages.landing.badgeSecure': '🔒 Sécurisé',
    'pages.landing.codeTitle': 'Exemple GraphQL',
    'pages.landing.compare.favorites.classic': '❌',
    'pages.landing.compare.favorites.label': 'Système de favoris',
    'pages.landing.compare.favorites.platform': '✅',
    'pages.landing.compare.filters.classic': '⚠️ Limités',
    'pages.landing.compare.filters.label': 'Filtres avancés',
    'pages.landing.compare.filters.platform': '✅ Complets',
    'pages.landing.compare.header.classic': 'Solutions classiques',
    'pages.landing.compare.header.feature': 'Fonctionnalité',
    'pages.landing.compare.header.platform': 'GitXplorer Project ListGithub',
    'pages.landing.compare.performance.classic': '⚠️ Variable',
    'pages.landing.compare.performance.label': 'Performance',
    'pages.landing.compare.performance.platform': '✅ Optimale',
    'pages.landing.compare.readme.classic': '❌',
    'pages.landing.compare.readme.label': 'Preview README',
    'pages.landing.compare.readme.platform': '✅',
    'pages.landing.compare.stats.classic': '⚠️ Basiques',
    'pages.landing.compare.stats.label': 'Statistiques détaillées',
    'pages.landing.compare.stats.platform': '✅ Avancées',
    'pages.landing.compare.ui.classic': '⚠️ Désuète',
    'pages.landing.compare.ui.label': 'Interface moderne',
    'pages.landing.compare.ui.platform': '✅ Moderne',
    'pages.landing.cta.button': 'Commencer maintenant',
    'pages.landing.cta.subtitle': 'Rejoignez des développeurs qui utilisent GitXplorer Project ListGithub pour gérer leurs projets GitHub efficacement',
    'pages.landing.cta.title': 'Prêt à explorer vos dépôts ?',
    'pages.landing.cta.trust1': '✅ Gratuit',
    'pages.landing.cta.trust2': '✅ Open Source',
    'pages.landing.cta.trust3': '✅ Sans inscription',
    'pages.landing.ctaLong': 'Commencer l\'exploration',
    'pages.landing.f0.desc': 'Parcourez tous vos dépôts GitHub avec pagination intelligente, filtres avancés et recherche en temps réel.',
    'pages.landing.f0.title': 'Exploration complète',
    'pages.landing.f1.desc': 'Filtrez par langage, topics, étoiles, forks, date de mise à jour et bien plus encore.',
    'pages.landing.f1.title': 'Recherche avancée',
    'pages.landing.f2.desc': 'Visualisez les README directement dans l\'interface avec un rendu HTML formaté.',
    'pages.landing.f2.title': 'Preview README',
    'pages.landing.f3.desc': 'Sauvegardez vos dépôts préférés et accédez-y rapidement avec un système persistant.',
    'pages.landing.f3.title': 'Système de favoris',
    'pages.landing.f4.desc': 'Analysez vos dépôts avec des métriques complètes : étoiles, forks, langages, et bien plus.',
    'pages.landing.f4.title': 'Statistiques détaillées',
    'pages.landing.f5.desc': 'Cache intelligent avec TTL automatique pour des réponses ultra-rapides et une expérience fluide.',
    'pages.landing.f5.title': 'Performance optimale',
    'pages.landing.f6.desc': 'Gestion sécurisée de vos tokens GitHub avec validation et stockage local.',
    'pages.landing.f6.title': 'Sécurité renforcée',
    'pages.landing.f7.desc': 'Monitoring complet avec Prometheus, Grafana et Alertmanager pour un suivi en temps réel.',
    'pages.landing.f7.title': 'Monitoring intégré',
    'pages.landing.feature.learnMore': 'En savoir plus →',
    'pages.landing.footer.brand': '📦 GitXplorer Project ListGithub',
    'pages.landing.footer.copy': '© 2024 GitXplorer Project ListGithub • Open Source',
    'pages.landing.footer.featLine1': 'Cache intelligent • Rate limiting',
    'pages.landing.footer.featLine2': 'Métriques Prometheus • Logging structuré',
    'pages.landing.footer.featTitle': 'Fonctionnalités',
    'pages.landing.footer.tagline': 'Exploration avancée des dépôts GitHub',
    'pages.landing.footer.techLine1': 'FastAPI • React • TypeScript',
    'pages.landing.footer.techLine2': 'Prometheus • Grafana • Docker',
    'pages.landing.footer.techTitle': 'Technologies',
    'pages.landing.heroDesc': 'GitXplorer Project ListGithub vous offre une interface moderne pour découvrir, filtrer et explorer vos dépôts — aperçu README, favoris, statistiques et plus encore.',
    'pages.landing.heroSubtitle': 'Filtres, favoris, aperçu README et statistiques — au même endroit.',
    'pages.landing.heroTitle': 'Explorez vos dépôts GitHub',
    'pages.landing.heroTitleA': 'Explorez et gérez vos dépôts GitHub',
    'pages.landing.heroTitleB': ' facilement',
    'pages.landing.logoSubtitle': 'Exploration GitHub avancée',
    'pages.landing.preview.favs': 'Favoris',
    'pages.landing.preview.readme': 'Preview README',
    'pages.landing.preview.stats': 'Statistiques',
    'pages.landing.s0.label': 'Dépôts explorés',
    'pages.landing.s1.label': 'Filtres disponibles',
    'pages.landing.s2.label': 'Temps de réponse',
    'pages.landing.s3.label': 'Disponibilité',
    'pages.landing.section.compareSubtitle': 'Comparez avec les solutions traditionnelles',
    'pages.landing.section.compareTitle': 'Pourquoi choisir GitXplorer Project ListGithub ?',
    'pages.landing.section.featuresSubtitle': 'Tout ce dont vous avez besoin pour explorer et gérer vos dépôts GitHub efficacement',
    'pages.landing.section.featuresTitle': 'Fonctionnalités puissantes',
    'pages.landing.section.howSubtitle': 'En quelques étapes simples',
    'pages.landing.section.howTitle': 'Comment ça fonctionne',
    'pages.landing.section.testimonialsSubtitle': 'Découvrez comment GitXplorer Project ListGithub aide les développeurs à mieux gérer leurs projets',
    'pages.landing.section.testimonialsTitle': 'Ce que disent nos utilisateurs',
    'pages.landing.statsTitle': 'Pourquoi GitXplorer Project ListGithub',
    'pages.landing.step1.desc': 'Ajoutez votre token GitHub personnel pour accéder à vos dépôts privés',
    'pages.landing.step1.title': 'Configurez votre token',
    'pages.landing.step2.desc': 'Parcourez tous vos dépôts avec des filtres avancés et une recherche puissante',
    'pages.landing.step2.title': 'Explorez vos dépôts',
    'pages.landing.step3.desc': 'Visualisez les README, ajoutez aux favoris et consultez les statistiques',
    'pages.landing.step3.title': 'Analysez et gérez',
    'pages.landing.t0.name': 'Alex Dev',
    'pages.landing.t0.role': 'Développeur full-stack',
    'pages.landing.t0.text': 'GitXplorer Project ListGithub a transformé ma façon de gérer mes dépôts GitHub. Les filtres avancés et le preview README sont incroyables !',
    'pages.landing.t1.name': 'Sarah Tech',
    'pages.landing.t1.role': 'Tech lead',
    'pages.landing.t1.text': 'L\'interface est intuitive et les statistiques me permettent de mieux comprendre mes projets. Un outil indispensable !',
    'pages.landing.t2.name': 'Mike Code',
    'pages.landing.t2.role': 'Contributeur open source',
    'pages.landing.t2.text': 'Le système de favoris et la recherche avancée m\'aident à organiser mes centaines de dépôts. Excellent travail !',
    'pagination.next': 'Suivant ▶',
    'pagination.nextAria': 'Page suivante',
    'pagination.pageOf': 'Page {current} / {total}',
    'pagination.prev': '◀ Précédent',
    'pagination.prevAria': 'Page précédente',
    'pagination.totalRepos': '({total} dépôts)',
    'readme.close': 'Fermer',
    'readme.closeAria': 'Fermer',
    'readme.empty': 'Aucun README disponible pour ce dépôt',
    'readme.loadError': 'Erreur lors du chargement du README',
    'readme.loading': 'Chargement du README…',
    'readme.notFound': 'README non disponible pour ce dépôt',
    'readme.openGithub': '📂 Voir sur GitHub',
    'readme.subtitle': '{owner}/{repo}',
    'readme.title': 'README — {repo}',
    'repo.archivedBadge': 'Archivé',
    'repo.deployBadge': 'Déploiement',
    'repo.github': '📂 GitHub',
    'repo.meta.forksTitle': 'Nombre de forks',
    'repo.meta.languageTitle': 'Langage de programmation',
    'repo.meta.starsTitle': 'Nombre d\'étoiles',
    'repo.moreTopics': '+{n}',
    'repo.openApp': '🌐 Ouvrir l\'app',
    'repo.readme': '📖 README',
    'repo.topicTitle': 'Topic : {topic}',
    'results.count': '{n} dépôt affiché',
    'results.countPlural': '{n} dépôts affichés',
    'results.ofTotal': ' sur {total}',
    'stats.card.activeRepos': 'Dépôts actifs',
    'stats.card.languages': 'Langages',
    'stats.card.totalForks': 'Total de forks',
    'stats.card.totalRepos': 'Total de dépôts',
    'stats.card.totalStars': 'Total d\'étoiles',
    'stats.card.withDeploy': 'Avec déploiement',
    'stats.extra.avg': 'Moyenne : {n}',
    'stats.extra.percent': '{n}%',
    'stats.extra.top': 'Top : {name}',
    'stats.extra.totalLabel': 'Total : {n}',
    'stats.title': '📊 Statistiques',
    'stats.topLanguages': '🔝 Top 5 langages',
    'stats.topics.one': '{n} topic unique',
    'stats.topics.other': '{n} topics uniques',
    'toast.tokenError': 'Erreur lors de l\'enregistrement du token',
    'toast.tokenRemoveError': 'Erreur lors de la suppression du token',
    'toast.tokenRemoved': 'Token GitHub supprimé',
    'toast.tokenSaved': 'Token GitHub enregistré avec succès !',
    'token.cancel': 'Annuler',
    'token.close': 'Fermer',
    'token.header': 'Token GitHub',
    'token.help.step1': 'Allez sur GitHub → Paramètres → Paramètres développeur → Jetons d\'accès personnel.',
    'token.help.step2': 'Cliquez sur « Generate new token (classic) ».',
    'token.help.step3': 'Sélectionnez les scopes : public_repo, read:user.',
    'token.help.step4': 'Copiez le token et collez-le ici.',
    'token.help.title': '💡 Comment obtenir un token GitHub',
    'token.help.warning': '⚠️ Important : le token est stocké localement dans votre navigateur et n\'est envoyé au serveur que pour les requêtes API GitHub.',
    'token.label': 'Token GitHub personnel',
    'token.placeholder': 'ghp_xxxxxxxxxxxxxxxxxxxx',
    'token.remove': '🗑️ Supprimer le token',
    'token.status.active': 'Token configuré',
    'token.status.inactive': 'Non configuré',
    'token.submit': '✅ Enregistrer le token',
    'token.toggle.collapse': 'Réduire',
    'token.toggle.expand': 'Développer',
    'token.validating': '⏳ Validation…',
    'token.visibility.hide': 'Masquer',
    'token.visibility.show': 'Afficher',
  },
}
